<template>
    <ies-form-field :field="field">
        <!-- list must be list of ['text' => x, 'value' => y] -->
        <v-autocomplete hide-details dense outlined
            v-model="viewValue"
            :items="options"
            autocomplete
        ></v-autocomplete>
        <input type="hidden" :name="field.fieldName" :value="field.value">
    </ies-form-field>
</template>

<script>
    import axios from 'axios';
    /**
     * Allows the setting of payment service provider by choosing their name from a list
     */
    export default {
        name: 'ies-paymentProviderKey',
        props: ['field'],
        components: {
            'ies-form-field': require('./FormField.vue').default,
        },
        data() {
            return {
                providers: [],
                options: [],
                viewValue: parseInt(this.field.value),
            }
        },
        created:function() {
            this.getProviders();
        },
        methods: {
            getProviders:function(){
                axios.get('/api/accounts/payment-service-providers')
                .then(function(response){
                    this.providers = response.data;
                    this.setOptions();
                }.bind(this));
            },

            setOptions:function(){
                var options = [];
                this.providers.forEach(function(provider){
                    options.push({text: provider.name, value: provider.payment_provider_key});
                });
                this.options = options;
            },
        },
        watch: {
            viewValue: function (newValue) {
                this.field.value = newValue;
            }
        }
    }
</script>
